/**
 * Video Player
 * Videos are played from BrightCove, and rendered using the BrighCove player
 *
 * Usage
 * This player is only imported into the KeyHighlight component, and not used by
 * the Videos module
 *
 * @see https://videojs.com
 * @see https://www.brightcove.com/en/
 *
 * @todo Should have defaults for the props and spread these in propTypes
 */

/* eslint no-return-assign: "error" */
import * as React from 'react'
import loadable from '@loadable/component'
// import 'video.js/dist/video-js.css'

const VideoLibrary = loadable.lib(() => import('video.js'))

interface VideoPlayerPropsInferface {
  videojs?: any
}

class VideoPlayer extends React.Component<VideoPlayerPropsInferface> {
  private player?: videojs.VideoJsPlayer

  private videoNode?: HTMLVideoElement

  constructor(props: VideoPlayerPropsInferface) {
    super(props)

    this.player = undefined
    this.videoNode = undefined
  }

  componentDidMount() {
    // eslint-disable-next-line react/destructuring-assignment
    this.player = this.props.videojs(this.videoNode, this.props)
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <div
        data-vjs-player="true"
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          background: 'transparent'
        }}
      >
        <video
          muted
          ref={(node: HTMLVideoElement) => (this.videoNode = node)}
          className="video-js"
        />
      </div>
    )
  }
}

export default (props: VideoPlayerPropsInferface) => (
  <VideoLibrary>
    {({ default: videojs }) => <VideoPlayer {...props} videojs={videojs} />}
  </VideoLibrary>
)
